import { TaskAnswer } from './task_template_answer';
export class Topology {
    topology :string="p00"
    body :string[]=[]
    answer:TaskAnswer = new TaskAnswer()

}
